import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import useAlert from "../../components/CustomAlert";

export default function AddInstructionModal({ show, onHide, groupId, onSave }) {
    const { alert, showAlert, hideAlert } = useAlert();
    const [instructionTitle, setInstructionTitle] = useState("");
    const [instructionFile, setInstructionFile] = useState(null);

    const handleSave = async () => {

        if (!instructionTitle || !instructionFile) {
            showAlert("Wszystkie pola są wymagane.", "warning");
            return;
        }

        hideAlert();

        const formData = new FormData();
        formData.append("title", instructionTitle);
        formData.append("file", instructionFile);
        formData.append("group_id", groupId);

        await onSave(formData, {
            onSuccess: () => {
                setInstructionTitle("");
                setInstructionFile(null);
                onHide();
            },
            onError: (msg) => showAlert(msg, "danger")
        });
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Dodaj instrukcję</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {alert()}
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Nazwa instrukcji</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Wprowadź nazwę"
                            value={instructionTitle}
                            onChange={(e) => setInstructionTitle(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Plik</Form.Label>
                        <Form.Control
                            type="file"
                            onChange={(e) => setInstructionFile(e.target.files[0])}
                            accept=".pdf"
                            required
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Anuluj</Button>
                <Button variant="primary" onClick={handleSave}>Zapisz</Button>
            </Modal.Footer>
        </Modal>
    );
}
